import { AlertTriangle } from "lucide-react";
import {
  STEP_LABELS,
  type ProvisionStep,
} from "@/application/provisioning/types";

interface ErrorBannerProps {
  failedStep: string;
  failedError: string;
  retryCount: number;
  updatedAt: string;
}

export function ErrorBanner({
  failedStep,
  failedError,
  retryCount,
  updatedAt,
}: ErrorBannerProps) {
  return (
    <div className="flex items-start gap-3 rounded-lg border border-red-200 bg-red-50 p-4">
      <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-red-600" />
      <div>
        <div className="text-sm font-semibold text-red-700">
          Failed at: {STEP_LABELS[failedStep as ProvisionStep] ?? failedStep}
        </div>
        <div className="mt-1 text-sm text-red-600">{failedError}</div>
        <div className="text-muted-foreground mt-1 text-xs">
          {retryCount > 0 ? `Retry #${retryCount} · ` : ""}
          Last attempt: {new Date(updatedAt).toLocaleString()}
        </div>
      </div>
    </div>
  );
}
